import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var AlarmClock = createReactComponent("AlarmClock", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "13",
  r: "8",
  key: "8t7gpc"
}], ["path", {
  d: "M12 9v4l2 2",
  key: "ap5om0"
}], ["path", {
  d: "M5 3L2 6",
  key: "yo78bm"
}], ["path", {
  d: "M22 6l-3-3",
  key: "ry34ie"
}], ["path", {
  d: "M6 19l-2 2",
  key: "1dpmc8"
}], ["path", {
  d: "M18 19l2 2",
  key: "1v10ht"
}]]]);
export default AlarmClock;